import { exceptionHandler } from './helperException';

export function getBrand(brand) {
    switch (brand?.toLowerCase()) {
        case "as":
        case "accesss":
        case "accesstorage":
        case "accessstorage":
        case "accessstroages":
        case "access storage":
            return { logo: "logo-accessstorage.png", name: "Access Storage", color: "danger", defaultLanguage: 'en' };
        case "portable-storage":
        case "portablestorage":
        case "cubeitportablestorage":
        case "costcoconstco":
        case "cubeit":
            return { logo: "logo-cubeit.png", name: "Cubeit", color: "primary", defaultLanguage: 'en' };
        case "depotium":
        case "depotiumstorage":
            return { logo: "logo-depotium.png", name: "Depotium", color: "success", defaultLanguage: 'fr' };
        case "fs":
        case "flexspace":
            return { logo: "logo-flexspace.png", name: "Flexspace", color: "danger", defaultLanguage: 'en' };
        case "mb":
        case "movebuddy":
            return { logo: "logo-movebuddy.png", name: "MoveBuddy", color: "primary", defaultLanguage: 'en' };
        case "pups":
        case "canadianpupsportablestorage":
        case "canadian pups portable storage":
            return { logo: "logo-pups.png", name: "PUPS", color: "danger", defaultLanguage: 'en' };
        case "realstorage":
            return { logo: "logo-realstorage.png", name: "Real Storage", color: "danger", defaultLanguage: 'en' };
        case "recordxpress":
            return { logo: "logo-recordxpress.png", name: "RecordXpress", color: "warning", defaultLanguage: 'en' };
        case "safeselfstorage":
        case "ssstorages":
        case "ssstorage":
            return { logo: "logo-safeselfstorage.png", name: "Safe Self Storage", color: "danger", defaultLanguage: 'en' };
        case "sentinel":
        case "sentinelstorage":
            return { logo: "logo-sentinel.png", name: "Sentinel", color: "danger", defaultLanguage: 'en' };
        case "sfyl":
        case "storageforyourlife":
            return { logo: "logo-storageforyourlife.png", name: "SFYL", color: "primary", defaultLanguage: 'en' };
        case "spacesstorage":
            return { logo: "logo-spacesstorage.png", name: "Spaces Storage", color: "dark", defaultLanguage: 'en' };
        case "svi":
        case "storagevault":
        case "storagevaultcanada":
        case "storagevault canada":
            return { logo: "logo-storagevault.png", name: "StorageVault Canada", color: "danger", defaultLanguage: 'en' };
        case "storagevaultmanagement":
            return { logo: "logo-storagevaultmanagement.png", name: "Storage Vault Management", color: "danger", defaultLanguage: 'en' };
        case "storemore":
        case "storeandmore":
        case "store&more":
            return { logo: "logo-storemore.png", name: "Store & More", color: "dark", defaultLanguage: 'en' };
        case "svic":
        case "svi-c":
        case "svicontainers":
        case "storagevault-container":
        case "storagevault-containers":
        case "storagevault container":
        case "storagevault containers":
            return { logo: "logo-storagevault-container.png", name: "StorageVault Containers", color: "danger", defaultLanguage: 'en' };
        case "valet":
            return { logo: "logo-storagevault.png", name: "Valet", color: "dark", defaultLanguage: 'en' };
        case "staff":
            return { logo: "logo-storagevault.png", name: "Staff", color: "dark", defaultLanguage: 'en' };
        default:
            exceptionHandler(null, "getBrand: Unknown brand", { brand });
            return { logo: "logo-storagevault.png", name: "StorageVault Canada", color: "danger", defaultLanguage: 'en' };
    }
}
